import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseConfigService, loadConf } from './config/base.service';


@Injectable({
  providedIn: 'root'
})
export class PortailTransLoader implements TranslateLoader {

  remoteUrl = 'conf/translation';

  storedTranslation = {};

  constructor(
    private http: HttpClient,
    private baseConfigService: BaseConfigService
  ) { }

  getTranslation(lang: string): Observable<any> {
    // let conf = this.baseConfigService.getFirstConf("translation").content;
    // return of(conf);
    return this.baseConfigService.getFirstConf$("translation").pipe(
      map((conf: loadConf) => conf.content)
    )

    return this.baseConfigService.firstLoadConfigs$
  }

  save(modifiedTranslation) {
    return this.http.put(this.remoteUrl, modifiedTranslation);
  }
}
